export enum PqrsEvent {
  userLogin = '[App Resident PEI] User Login',
  homeViewed = '[App Resident PEI] Home viewed',
  newPqrsStarted = '[App Resident PEI] New PQRS Started',
  newPqrsCreated = '[App Resident PEI] New PQRS Created',
  pqrsFilterUsed = '[App Resident PEI] PQRS filter used',
  pqrsOpened = '[App Resident PEI] PQRS Opened',
  userLogOut = '[App Resident PEI] User Log Out',
  passwordUpdated = '[App Resident PEI] Password Updated'
}

export enum PqrsType {
  peticion = 'Petición',
  queja = 'Queja',
  reclamo = 'Reclamo',
  sugerencia = 'Sugerencia',
  felicitacion = 'Felicitación'
}

export enum PqrsStatus {
  pending = 'Pendiente',
  active = 'Activo',
  completed = 'Cerrado',
  rejected = 'Rechazada'
}

export class PqrsGenericEvent {}

export class NewPqrsStarted extends PqrsGenericEvent {
  'Helpdesk': boolean;
}

export class NewPqrsCreated extends PqrsGenericEvent {
  'Helpdesk': boolean;
  'PQRS Category/Request type': PqrsType;
  'PH Unit Number': string;
  'Typology': string;
  'Sub Typology': string;
  'PQRS Title/Description': string;
}

export class PqrsFilterUsed extends PqrsGenericEvent {
  'Filters type': string[];
  'Filters value': string[];
}

export class UserLogin extends PqrsGenericEvent {
  'User ID': string;
  'Name': string;
  'Email': string;
  'Building': string;
  'Unit': string;
}

export class UserLogOut extends PqrsGenericEvent {}
export class PasswordUpdated extends PqrsGenericEvent {}
export class PqrsOpened extends PqrsGenericEvent {}
export class HomeViewed extends PqrsGenericEvent {}
export type PqrsEventData =
  | NewPqrsStarted
  | NewPqrsCreated
  | PqrsFilterUsed
  | PqrsOpened
  | UserLogOut
  | PasswordUpdated
  | UserLogin
  | HomeViewed;

export type PqrsEventRecord = Record<string, PqrsEventData>;

export const PQRS_MTS_PEI_APP_NAME = "PQRS_MTS_PEI";
export const PQRS_MTS_PEI_ID = "PQRS_MTS_PEI_AMPLITUDE";